module.exports = __webpack_public_path__ + "static/media/_ARK2987.443dade3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cafeteria/_ARK2987.jpg
// module id = 1148
// module chunks = 0